import React, { Component } from "react"
import './UnavailableDialog.scss'
import { Dialog } from "@material-ui/core"
import i18n from "@/i18n"

class UnavailableDialog extends Component {

    render() {
        const { onClose, open } = this.props
        return (
            <Dialog maxWidth={"lg"} open={open} onClose={onClose}>
                <div className="unavailable-dialog-container">
                    <div className="dialog-text">
                        {i18n.t('makevideo.ratiopalette.unavailable.dialog.text')}
                    </div>
                    <div className="dialog-btn" onClick={onClose}>{i18n.t("global.confirm")}</div>
                </div>
            </Dialog>
        )
    }
}

export default UnavailableDialog
